import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import { GetAllTE_OS_NatureOfSupport } from "../../../../Redux/Reducers/ProjectInformationPage/OtherProjectSupport/DropDownForNatutralOfWork";
import AddOtherProjectSupport from "../../../../Services/ProjectInformationPage/OtherProjectSupport/AddOtherProjectSupport";
import UpdateOtherProjectSupport from "../../../../Services/ProjectInformationPage/OtherProjectSupport/UpdateOtherProjectSupport";
import {
  GetOneOtherProjectSupport,
  restValidationOtherProjectSupport,
  ValidateOtherProjectSupport,
} from "../../../../Redux/Reducers/ProjectInformationPage/OtherProjectSupport/indexOne";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import Swal from "sweetalert2";

const AddEditAdditionalSponsors = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      DropDownNatureOfSupport:
        state.DropDownNatureOfSupport.DropDownNatureOfSupport,
      OneOtherProjectSupport:
        state.OneOtherProjectSupport.OneOtherProjectSupport,
      loadingOneOtherProjectSupport:
        state.OneOtherProjectSupport.loadingOneOtherProjectSupport,
      TeamMembersPreviousExperiencePartnerships:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships,
      tE_MAinTeamMembersPreviousExperiencePartnershipsId:
        state.TeamMembersPreviousExperiencePartnerships
          .TeamMembersPreviousExperiencePartnerships
          .tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        state.tE_MAinTeamMembersPreviousExperiencePartnershipsId
          ?.tE_TeamMembersPreviousExperiencePartnershipsId,

      OtherProjectSupportValidate:
        state.OneOtherProjectSupport.OtherProjectSupportValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });

  //console.log(state.OneOtherProjectSupport, "one");
  // Function to format number with commas
  const numberWithCommas = (x) => {
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // Initialize state for managing additional sponsors data
  const [AdditionalSponsorsList, setAdditionalSponsorsList] = useState({
    tE_OS_OtherSupportingOrganizationsId:
      state.OneOtherProjectSupport?.tE_OS_OtherSupportingOrganizationsId,
    organizationName: state.OneOtherProjectSupport?.organizationName,
    tE_OS_NatureOfSupportId:
      state.OneOtherProjectSupport?.tE_OS_NatureOfSupportId,
    supportDetails: state.OneOtherProjectSupport?.supportDetails,
    supportAmountIfMonetary:
      state.OneOtherProjectSupport?.supportAmountIfMonetary,
    tE_TeamMembersPreviousExperiencePartnershipsId:
      state.OneOtherProjectSupport
        ?.tE_TeamMembersPreviousExperiencePartnershipsId,
    tE_MAinTeamMembersPreviousExperiencePartnershipsId:
      state.tE_TeamMembersPreviousExperiencePartnershipsId,
  });
  // Fetch nature of support dropdown data when component mounts
  useEffect(() => {
    dispatch(GetAllTE_OS_NatureOfSupport());
  }, []);

  // const AddAdditional = async () => {
  //   await AddOtherProjectSupport(
  //     AdditionalSponsorsList.organizationName,
  //     AdditionalSponsorsList.tE_OS_NatureOfSupportId,
  //     AdditionalSponsorsList.supportDetails,
  //     AdditionalSponsorsList.supportAmountIfMonetary,
  //     AdditionalSponsorsList.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };

  const AddAdditional = async () => {
    // Function to add new additional sponsor
    const validationList = await dispatch(
      ValidateOtherProjectSupport({
        organizationName: AdditionalSponsorsList.organizationName,
        tE_OS_NatureOfSupportId: AdditionalSponsorsList.tE_OS_NatureOfSupportId,
        supportDetails: AdditionalSponsorsList.supportDetails,
        supportAmountIfMonetary: AdditionalSponsorsList.supportAmountIfMonetary,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If validation passes, add new sponsor data
    if (validationList.payload.length === 0) {
      await AddOtherProjectSupport(
        AdditionalSponsorsList.organizationName,
        AdditionalSponsorsList.tE_OS_NatureOfSupportId,
        AdditionalSponsorsList.supportDetails,
        AdditionalSponsorsList.supportAmountIfMonetary,
        AdditionalSponsorsList.tE_TeamMembersPreviousExperiencePartnershipsId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    dispatch(restValidationOtherProjectSupport());
  }, []);

  // const UpdateAdditional = async () => {
  //   await UpdateOtherProjectSupport(
  //     AdditionalSponsorsList.tE_OS_OtherSupportingOrganizationsId,
  //     AdditionalSponsorsList.organizationName,
  //     AdditionalSponsorsList.tE_OS_NatureOfSupportId,
  //     AdditionalSponsorsList.supportDetails,
  //     AdditionalSponsorsList.supportAmountIfMonetary,
  //     AdditionalSponsorsList.tE_TeamMembersPreviousExperiencePartnershipsId
  //   );
  //   $(".close-btn").trigger("click");
  //   dispatch(setRefreshTable());
  // };

  const UpdateAdditional = async () => {
    // Function to update existing sponsor data

    const validationList = await dispatch(
      ValidateOtherProjectSupport({
        organizationName: AdditionalSponsorsList.organizationName,
        tE_OS_NatureOfSupportId: AdditionalSponsorsList.tE_OS_NatureOfSupportId,
        supportDetails: AdditionalSponsorsList.supportDetails,
        supportAmountIfMonetary: AdditionalSponsorsList.supportAmountIfMonetary,
      })
    );
    // If validation passes, update sponsor data
    if (validationList.payload.length === 0) {
      await UpdateOtherProjectSupport(
        AdditionalSponsorsList.tE_OS_OtherSupportingOrganizationsId,
        AdditionalSponsorsList.organizationName,
        AdditionalSponsorsList.tE_OS_NatureOfSupportId,
        AdditionalSponsorsList.supportDetails,
        AdditionalSponsorsList.supportAmountIfMonetary,
        AdditionalSponsorsList.tE_TeamMembersPreviousExperiencePartnershipsId
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  // Fetch additional sponsor data if props are provided
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOneOtherProjectSupport(props.tE_OS_OtherSupportingOrganizationsId)
      );
    }
  }, [props.tE_OS_OtherSupportingOrganizationsId]);
  // Update the additional sponsors list state when the data is fetched
  useEffect(() => {
    if (
      !state.loadingOneOtherProjectSupport &&
      Object.keys(props).length != 0
    ) {
      setAdditionalSponsorsList({
        ...state.OneOtherProjectSupport,
      });
    } else {
      setAdditionalSponsorsList({
        organizationName: null,
        tE_OS_NatureOfSupportId: null,
        supportDetails: null,
        supportAmountIfMonetary: null,
        tE_TeamMembersPreviousExperiencePartnershipsId:
          state.tE_MAinTeamMembersPreviousExperiencePartnershipsId,
      });
    }
  }, [state.OneOtherProjectSupport]);

  //console.log(AdditionalSponsorsList, "AdditionalSponsorsList");
  //console.log(AdditionalSponsorsList?.supportAmountIfMonetary, "number");

  const shouldDisableFields = !(

   //[,]
// مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
state.ActiveRound ==
      state.ApplicationInformation?.aI_RoundYearId &&
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
    window.location.href.includes("manager") == false

  );
  return (
    <>
      {!state.loadingOneOtherProjectSupport ? (
        <>
          <div className="AddEdite">
            <TextAreaAHSF
              fieldsName="NameOfTheEntity"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setAdditionalSponsorsList({
                  ...AdditionalSponsorsList,
                  organizationName: e.target.value,
                });
              }}
              defaultValue={AdditionalSponsorsList?.organizationName}
              showValidationMessage={
                state.OtherProjectSupportValidate
                  ? state.OtherProjectSupportValidate.includes(
                      "NameOfTheEntity"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="NatureOfSupport"
              show={true}
              disabled={shouldDisableFields}
              arrayOoptionList={state.DropDownNatureOfSupport}
              KeyText={"natureOfSupportAr"}
              KeyValue={"tE_OS_NatureOfSupportId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setAdditionalSponsorsList({
                  ...AdditionalSponsorsList,
                  tE_OS_NatureOfSupportId: Number(e.target.value),
                });
              }}
              defaultValue={AdditionalSponsorsList.tE_OS_NatureOfSupportId}
              showValidationMessage={
                state.OtherProjectSupportValidate
                  ? state.OtherProjectSupportValidate.includes(
                      "NatureOfSupport"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="SupportDetails"
              show={true}
              disabled={shouldDisableFields}
              onChange={(e) => {
                setAdditionalSponsorsList({
                  ...AdditionalSponsorsList,
                  supportDetails: e.target.value,
                });
              }}
              defaultValue={AdditionalSponsorsList?.supportDetails}
              showValidationMessage={
                state.OtherProjectSupportValidate
                  ? state.OtherProjectSupportValidate.includes("SupportDetails")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="SupportValueFinancial"
              show={true}
              disabled={shouldDisableFields}
              comma={true}
              onChange={(e) => {
                setAdditionalSponsorsList({
                  ...AdditionalSponsorsList,
                  supportAmountIfMonetary:
                    e.target.value === "" ? null : Number(e.target.value),
                });
              }}
              defaultValue={numberWithCommas(
                state.OneOtherProjectSupport?.supportAmountIfMonetary
              )}
              showValidationMessage={
                state.OtherProjectSupportValidate
                  ? state.OtherProjectSupportValidate.includes(
                      "SupportValueFinancial"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateAdditional()
                        : AddAdditional();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneOtherProjectSupport} />
    </>
  );
};

export default AddEditAdditionalSponsors;
